import { GlobalVars } from "../../../state/global/globalVars";
import UilCheck from "@iconscout/react-unicons/icons/uil-check";

export default function Checkbox(props) {
    const {
		name,
        label,
        onChange,
        checked,
        disabled,
        error,
        className,
        small,
        id,
        ...rest
    } = props;

    return (
        <div className={className}>
            <label
                {...rest}
                className="flex items-center space-x-3 w-fit"
            >
                <div
                    className={`border rounded ${small ? "w-3.5 h-3.5" : "w-5 h-5 min-w-[20px]"} hover:cursor-pointer ${disabled ? "bg-light-8 border-light-4" : checked ? "bg-light-3 border-light-3" : "bg-light-11 border-light-4"}`}
                >
                    {checked && (
                        <UilCheck size={small ? GlobalVars.iconSize.xs : GlobalVars.iconSize.md} className="-ml-[3px] -mt-[3px] text-light-11"/>
                    )}
                </div>
                <p className="text-sm font-semibold">
                    {label}
                </p>
                <input
					name={name}
                    className="hidden"
                    type="checkbox"
                    disabled={disabled}
                    checked={checked}
                    id={id}
                    onChange={onChange}
                />
            </label>
            {
                error && (
                    <p className="text-red-500 text-xs italic">
                        {error}
                    </p>
                )
            }
        </div>
    );
}

/*

Sample Props

label="Checkbox"
small={false}
onChange={e => setValue(e.target.checked)}
checked={value}
error="Error message"

 */
